import React from 'react'
import { RotateCw } from 'react-feather';

const Captcha = ({captchaValue,onClick,onChange}) => {
  return (
    <div className='captchaWraper' onChange={onChange}>
        <span>{captchaValue}</span>
        <button onClick={onClick}><RotateCw /></button>
      </div>
  )
}

export default Captcha